import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BEInstrumentationCoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. Instrumentation and Control Engineering",
    shortName: "B.E. ICE",
    duration: "4 years",
    description: "Specialized engineering program focusing on measurement, control systems, and process automation",
    overview: "Bachelor of Engineering in Instrumentation and Control Engineering (B.E. ICE) is a 4-year undergraduate program that combines elements of electrical, electronics, and mechanical engineering to design and maintain instruments and control systems. This course covers sensors, actuators, control theory, automation, and process instrumentation used in industries for monitoring and controlling various processes.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores",
      "Interest in automation and control systems"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Engineering Graphics",
          "Basic Electrical and Electronics",
          "Introduction to Instrumentation"
        ]
      },
      {
        year: 2,
        subjects: [
          "Electronic Devices and Circuits",
          "Digital Electronics",
          "Sensors and Transducers",
          "Circuit Analysis",
          "Signals and Systems",
          "Materials Science"
        ]
      },
      {
        year: 3,
        subjects: [
          "Control Systems Engineering",
          "Process Control",
          "Industrial Instrumentation",
          "Microprocessors and PLCs",
          "Data Acquisition Systems",
          "Analytical Instrumentation"
        ]
      },
      {
        year: 4,
        subjects: [
          "Advanced Control Systems",
          "Industrial Automation",
          "SCADA and HMI Systems",
          "Biomedical Instrumentation",
          "Project Work",
          "Industrial Training"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Instrumentation Engineer",
        "Control Systems Engineer",
        "Automation Engineer",
        "Process Engineer",
        "Test and Measurement Engineer",
        "Quality Control Engineer",
        "R&D Engineer",
        "Application Engineer",
        "Technical Sales Engineer",
        "Maintenance Engineer"
      ],
      industries: [
        "Oil and Gas Industry",
        "Chemical and Petrochemical",
        "Power Generation Plants",
        "Pharmaceutical Industry",
        "Food and Beverage Processing",
        "Aerospace and Defense",
        "Automotive Industry",
        "Steel and Metal Industries",
        "Water Treatment Plants",
        "Research Laboratories"
      ],
      averageSalary: "₹5-10 LPA (Fresher), ₹18-40 LPA (Experienced)",
      topRecruiters: [
        "ONGC, IOCL, BPCL",
        "Honeywell, Siemens, ABB",
        "L&T, Godrej",
        "NTPC, BHEL",
        "Emerson, Yokogawa",
        "Tata Steel, JSW Steel"
      ]
    },

    admissionProcess: [
      "TNEA Counselling (for Tamil Nadu colleges)",
      "JEE Main (for NITs and central universities)",
      "State-level entrance exams",
      "Management quota admissions",
      "Direct admission based on 12th marks"
    ],

    topColleges: [
      {
        name: "College of Engineering Guindy, Anna University",
        location: "Chennai",
        fees: "₹2,00,000",
        ranking: "NIRF Ranking: 35"
      },
      {
        name: "MIT Campus, Anna University",
        location: "Chennai",
        fees: "₹2,20,000",
        ranking: "NIRF Ranking: 48"
      },
      {
        name: "PSG College of Technology",
        location: "Coimbatore",
        fees: "₹4,50,000",
        ranking: "NIRF Ranking: 42"
      },
      {
        name: "Coimbatore Institute of Technology",
        location: "Coimbatore",
        fees: "₹3,80,000",
        ranking: "NAAC A+ Grade"
      }
    ],

    skills: [
      "Control System Design",
      "PLC Programming",
      "SCADA Systems",
      "LabVIEW Programming",
      "MATLAB/Simulink",
      "Process Control",
      "Sensor Calibration",
      "Industrial Automation",
      "Data Analysis",
      "Troubleshooting and Maintenance"
    ],

    futureScope: "Excellent growth prospects with Industry 4.0, smart manufacturing, IoT sensors, and increasing automation across all industries driving demand for instrumentation engineers.",

    faqs: [
      {
        question: "What industries hire Instrumentation Engineers?",
        answer: "Major hiring industries include oil & gas, chemical, pharmaceutical, power plants, automotive, aerospace, and any industry requiring process monitoring and control."
      },
      {
        question: "Is programming knowledge required?",
        answer: "Yes, knowledge of PLC programming, SCADA systems, LabVIEW, and MATLAB is essential for modern instrumentation engineering roles."
      },
      {
        question: "What are the job prospects in government sector?",
        answer: "Excellent opportunities in PSUs like ONGC, IOCL, NTPC, BHEL, and government research organizations like ISRO and DRDO."
      },
      {
        question: "Can I specialize in biomedical instrumentation?",
        answer: "Yes, biomedical instrumentation is a growing field with opportunities in medical device companies, hospitals, and healthcare technology firms."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BEInstrumentationCoursePage;
